import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Switch from "@mui/material/Switch";
import { Card, Grid, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class HomeScreen extends Component {
  state = {
    levels: [],
    per_page: 20,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      totalDocs: 0,
      limit: 20,
    },
    notification: false,
    message: "",
    notiColor: "success",
    loading: false,
  };

  componentDidMount() {
    this.getAllLevels(this.state.page_no, this.state.per_page);
  }

  // 🔥 POST API
  getAllLevels = async (page = 1, limit = 20) => {
    this.setState({ loading: true });

    if (init() !== "success") return;

    try {
      const resp = await axios.post(Constants.getUrls.getAllHomeScreen, {
        page,
        limit,
      });
      console.log(resp);

      if (resp.data.status == true) {
        const data = resp.data.data.rows || [];

        const pagination = {
          page: resp.data.page || page,
          limit: resp.data.limit || limit,
          totalDocs: resp.data.total || data.length,
          totalPages:
            resp.data.totalPages ||
            Math.ceil((resp.data.total || data.length) / limit),
          hasNextPage: resp.data.hasNextPage,
          hasPrevPage: resp.data.hasPrevPage,
        };

        this.setState({
          levels: data,
          pagination,
          loading: false,
        });
      } else {
        this.setState({
          notification: true,
          message: resp.data.message,
          loading: false,
          notiColor: "warning",
        });
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Something went wrong!",
        loading: false,
        notiColor: "warning",
      });
    }
  };

  handlePageChange = (page) => {
    this.getAllLevels(page, this.state.per_page);
  };

  handleEntriesPerPageChange = (limit) => {
    this.setState({ per_page: limit }, () => {
      this.getAllLevels(1, limit);
    });
  };

  // 🔥 Delete API (POST)
  handleDelete = async (id) => {
    if (!window.confirm("Delete this level?")) return;

    try {
      const resp = await axios.post(Constants.deleteUrls.deleteHomeScreen, {
        id,
      });

      this.setState({
        notification: true,
        message: resp.data.message || "Deleted",
        notiColor: "success",
      });

      this.getAllLevels(this.state.pagination.page, this.state.per_page);
    } catch (err) {
      console.log(err);
      
      this.setState({
        notification: true,
        message: "Delete failed!",
        notiColor: "warning",
      });
    }
  };

  handleStatusChange = async (id, currentStatus) => {
    if (init() !== "success") return;

    const newStatus = currentStatus == 1 ? 0 : 1;

    try {
      const resp = await axios.post(Constants.putUrls.changeHomeScreenStatus, {
        id,
        status: newStatus,
      });

      if (resp.data.status) {
        this.setState({
          notification: true,
          message: resp.data.message || "Status updated",
          notiColor: "success",
        });
        setTimeout(() => {
          this.setState({
            notification: false
          })
        }, 3000);

        // refresh list
        this.getAllLevels(this.state.pagination.page, this.state.per_page);
      } else {
        this.setState({
          notification: true,
          message: resp.data.message || "Failed",
          notiColor: "warning",
        });
      }
    } catch (err) {
      console.log(err);
      
      this.setState({
        notification: true,
        message: "Status update failed!",
        notiColor: "warning",
      });
    }
  };

  render() {
    const { levels, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Home Screen List
              </MDTypography>
            </MDBox>

            {/* Create Button */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addhome">
                <MDButton variant="contained" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : levels.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial" },
                      { Header: "Image", accessor: "image" },
                      { Header: "Title", accessor: "title" },
                      { Header: "Status", accessor: "status" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: levels.map((item, index) => ({
                      serial:
                        (pagination.page - 1) * pagination.limit + (index + 1),

                      image: (
                        <img
                          src={Constants.imageDomain + item.image_path}
                          style={{
                            width: 50,
                            height: 50,
                            objectFit: "cover",
                            borderRadius: 6,
                          }}
                        />
                      ),

                      title: item.title,
                      sub_title: item.sub_title,
                      status: (
                        <Switch
                          checked={item.status == 1}
                          onChange={() =>
                            this.handleStatusChange(item.id, item.status)
                          }
                          color="info"
                        />
                      ),

                      action: (
                        <div style={{ display: "flex", gap: 10 }}>
                          {/* Edit */}
                          <Tooltip title="Edit">
                            <Link to={`/updatehome/${item.id}`}>
                              <IconButton color="info">
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          {/* Delete */}
                          <Tooltip title="Delete">
                            <IconButton
                              color="error"
                              onClick={() => this.handleDelete(item.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Levels Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              title="Home Screen"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
